export default __webpack_public_path__ + "static/media/droppedIcon.cf811f86.svg";